export default {"src":"/_next/static/media/Gynecological-Cancers.e2d40905.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};